import { Button } from "@mui/material";
import { useCreateAmlCheck } from "./hooks/useCreateAmlCheck";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

export const RunAmlCheckButton = ({ sailorId, isFirstCheck }) => {
  const { run } = useCreateAmlCheck();

  return (
    <Button
      size="small"
      variant="contained"
      startIcon={<PersonSearchIcon />}
      onClick={() => run(sailorId)}
    >
      Start {isFirstCheck ? "" : " New"} AML Check
    </Button>
  );
};
